import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { get_StringAdapter1plpsgiy8rwhj as get_StringAdapter } from '../../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapters.mjs';
import { get_partyIdAdapter2v7zx778kk10s as get_partyIdAdapter } from '../../../adapter/Adapter.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { GrantDiscordAccessInputqu7hxtlblgwv as GrantDiscordAccessInput } from '../GrantDiscordAccessInput.mjs';
import { Adapter1t72m9xaryzfb as Adapter } from '../../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapter.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var GrantDiscordAccessInput_InputAdapterClass;
function GrantDiscordAccessInput_InputAdapter() {
  if (GrantDiscordAccessInput_InputAdapterClass === VOID) {
    class $ {
      e40(reader, customScalarAdapters) {
        throw IllegalStateException().o('Input type used in output position');
      }
      m6r(writer, customScalarAdapters, value) {
        writer.h48('code');
        get_StringAdapter().f40(writer, customScalarAdapters, value.w6o_1);
        writer.h48('partyId');
        get_partyIdAdapter().f40(writer, customScalarAdapters, value.x6o_1);
        writer.h48('guildId');
        get_StringAdapter().f40(writer, customScalarAdapters, value.y6o_1);
      }
      f40(writer, customScalarAdapters, value) {
        return this.m6r(writer, customScalarAdapters, value instanceof GrantDiscordAccessInput() ? value : THROW_CCE());
      }
    }
    initMetadataForObject($, 'GrantDiscordAccessInput_InputAdapter', VOID, VOID, [Adapter()]);
    GrantDiscordAccessInput_InputAdapterClass = $;
  }
  return GrantDiscordAccessInput_InputAdapterClass;
}
var GrantDiscordAccessInput_InputAdapter_instance;
function GrantDiscordAccessInput_InputAdapter_getInstance() {
  return GrantDiscordAccessInput_InputAdapter_instance;
}
//region block: init
GrantDiscordAccessInput_InputAdapter_instance = new (GrantDiscordAccessInput_InputAdapter())();
//endregion
//region block: exports
export {
  GrantDiscordAccessInput_InputAdapter_instance as GrantDiscordAccessInput_InputAdapter_instance3msvaqtmlu6i,
};
//endregion

//# sourceMappingURL=GrantDiscordAccessInput_InputAdapter.mjs.map
